export interface ForumReply {
  id: string;
  userId: string;
  content: string;
  time: string;
}

export interface ForumTopic {
  id: string;
  title: string;
  content: string;
  authorId: string;
  createdAt: string;
  replyCount: number;
  viewCount: number;
  hot: boolean;
  replies: ForumReply[];
}

export const forumTopics: ForumTopic[] = [
  {
    id: 'f01',
    title: '大家觉得拍人像到底要不要修到"认不出"？',
    content: '最近发现很多作品修得很美，但完全看不出原本的样子了，想听听大家对人像后期尺度的看法。',
    authorId: 'u01',
    createdAt: '2026-09-29',
    replyCount: 4,
    viewCount: 1823,
    hot: true,
    replies: [
      { id: 'r01', userId: 'u04', content: '我觉得适度磨皮没问题，但五官都改了就不算摄影了，更像是绘画。', time: '2026-09-29 14:20' },
      { id: 'r02', userId: 'u02', content: '看用途吧，商业片和个人创作标准不一样，艺术创作可以更自由一点。', time: '2026-09-29 15:02' },
      { id: 'r03', userId: 'u05', content: '保留本人特征的前提下优化光影和色调，我觉得是比较合适的尺度。', time: '2026-09-29 16:45' },
      { id: 'r04', userId: 'u06', content: '同意楼上，过度修图容易失去照片本身的真实感和记录价值。', time: '2026-09-30 09:10' },
    ],
  },
  {
    id: 'f02',
    title: '新手求推荐一台一万以内的全画幅相机',
    content: '刚入坑摄影，预算一万左右，主要拍人像和风光，求各位大佬推荐机型。',
    authorId: 'u04',
    createdAt: '2026-09-27',
    replyCount: 6,
    viewCount: 2765,
    hot: true,
    replies: [
      { id: 'r05', userId: 'u01', content: '预算内可以看看二手的Sony A7M3，性价比很高，适合人像。', time: '2026-09-27 10:12' },
      { id: 'r06', userId: 'u02', content: '如果偏风光可以考虑佳能的R8，轻便适合户外长时间携带。', time: '2026-09-27 11:40' },
      { id: 'r07', userId: 'u03', content: '尼康Z5也不错，双卡槽实用性高。', time: '2026-09-27 13:05' },
      { id: 'r08', userId: 'u05', content: '建议先去实体店摸一摸手感，参数差不多的情况下手感更重要。', time: '2026-09-27 15:30' },
    ],
  },
  {
    id: 'f03',
    title: '分享一下我这次云南梯田采风的路线规划',
    content: '刚从元阳梯田回来，整理了一份拍摄点位和最佳时间的攻略，有需要的朋友可以参考。',
    authorId: 'u02',
    createdAt: '2026-09-24',
    replyCount: 3,
    viewCount: 1342,
    hot: false,
    replies: [
      { id: 'r09', userId: 'u06', content: '太实用了，正好最近在计划这条路线，谢谢分享！', time: '2026-09-24 20:11' },
      { id: 'r10', userId: 'u01', content: '请问当地住宿方便吗，大概提前多久预订比较好？', time: '2026-09-25 08:33' },
      { id: 'r11', userId: 'u02', content: '住宿点不多建议提前一周订，旺季人比较多。', time: '2026-09-25 09:02' },
    ],
  },
  {
    id: 'f04',
    title: '微距摄影到底需不需要专业微距镜头？',
    content: '看到有人用近摄接环也能拍出不错的效果，想问问老师傅们的意见。',
    authorId: 'u03',
    createdAt: '2026-09-20',
    replyCount: 2,
    viewCount: 986,
    hot: false,
    replies: [
      { id: 'r12', userId: 'u04', content: '入门阶段近摄接环完全够用，等确定了兴趣再上专业镜头也不迟。', time: '2026-09-20 18:40' },
      { id: 'r13', userId: 'u03', content: '同意，近摄环+手动镜头是性价比最高的入门组合。', time: '2026-09-21 09:15' },
    ],
  },
  {
    id: 'f05',
    title: '周末约拍活动：城市夜景长曝光小组',
    content: '周六晚上组织一次夜景长曝光拍摄活动，地点在解放碑附近，欢迎感兴趣的朋友报名。',
    authorId: 'u06',
    createdAt: '2026-09-18',
    replyCount: 5,
    viewCount: 1567,
    hot: true,
    replies: [
      { id: 'r14', userId: 'u05', content: '报名！需要自带三脚架吗？', time: '2026-09-18 19:02' },
      { id: 'r15', userId: 'u06', content: '需要的，三脚架和快门线都请自备哦。', time: '2026-09-18 19:20' },
      { id: 'r16', userId: 'u01', content: '可惜在外地没法参加，期待后续的作品分享。', time: '2026-09-19 08:15' },
    ],
  },
  {
    id: 'f06',
    title: '聊聊大家第一次让自己满意的作品',
    content: '每个人应该都有一张让自己真正满意、觉得"开窍了"的照片，分享一下你的故事吧。',
    authorId: 'u05',
    createdAt: '2026-09-14',
    replyCount: 7,
    viewCount: 2103,
    hot: false,
    replies: [
      { id: 'r17', userId: 'u02', content: '我的是第一次拍到完整日出云海的那张，至今都是头像。', time: '2026-09-14 21:03' },
      { id: 'r18', userId: 'u03', content: '第一次成功堆焦拍出蝴蝶翅膀全部清晰的那张，太有成就感了。', time: '2026-09-15 07:40' },
    ],
  },
];

export const getTopicById = (id: string) => forumTopics.find((t) => t.id === id);
export const getTopicsByAuthor = (authorId: string) =>
  forumTopics.filter((t) => t.authorId === authorId);